<template>
  <div id="manage" class="max-w-s mx-auto px-4 pt-4">

    <!-- valinta -->
    <div id="form-tabs" class="card mb-4 py-2">
      <ul class="flex justify-around">
        <li
          v-for="(choice, index) in choices"
          :key="index"
          @click="setTab(choice)"
          :class="{ highlighted: highlighted === choice.component }"
          class="txt-center px-4 py-2 rounded-3 font-9">
          <!-- <i class="material-icons block">{{ choice.icon }}</i> -->
          <span class="block txt-bold">{{ choice.title }}</span>
        </li>
      </ul>
    </div>

    <!-- form -->
    <keep-alive>
      <component :is="isTab" class="card px-10 pt-4 pb-6 mb-6"></component>
    </keep-alive>

  </div>
</template>

<script>
import topics from '@/components/mngTopics'
import means from '@/components/mngMeans'
import examples from '@/components/mngExamples'
import feedbacks from '@/components/mngFeedbacks'

export default {
  name: 'manage',

  components: {
    topics,
    means,
    examples,
    feedbacks
  },

  data () {
    return {
      choices: [
        { title: 'aiheet', component: 'topics', icon: 'add' },
        { title: 'keinot', component: 'means', icon: 'add' },
        { title: 'kohteet', component: 'examples', icon: 'add' },
        { title: 'palaute', component: 'feedbacks', icon: 'add' }
      ],
      isTab: null,
      highlighted: null
    }
  },

  methods: {
    setTab (data) {
      this.isTab = data.component
      if (this.highlighted === null || this.highlighted !== data.component) {
        this.highlighted = data.component
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/styles/styles.scss";

$form-border-color: rgb(200, 200, 200);
#manage {
  label {
    display: block;
    font-size: 0.7rem;
    font-weight: 500;
  }
  input[type="text"],
  input[type="password"],
  input[type="number"],
  input[type="email"], {
    height: 25px;
    padding: 0 8px;
    border: 1px solid $form-border-color;
    border-radius: 5px;
  }
  input {
    &:not([type="checkbox"]) { width: 100%; }
    &::-webkit-outer-spin-button, // for hiding input[type="number"] handle
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
    }
  }
  input[type="radio"] { width: auto !important; } //en saanut ujutettua tätä tuohon ylempään :not -selektoriin
  select {
    width: 100%;
    height: 25px;
  }
  textarea {
    resize: none; // removes the handle
    width: 100%;
    padding: 8px;
    border-radius: 5px;
  }
  input:not([type="file"]), textarea, select {
    outline: none;
    border: 1px solid $form-border-color;
    &:focus { border: 1px solid #002064; }
  }
  #form-tabs li:last-child { color: grey; }
}

#form-tabs {
  // color: red;
  & li {
    cursor: pointer;
    &:hover {
      background-color: rgb(230, 230, 230);
      font-weight: 700;
      //text-shadow: 0px 0px 1px rgba(0, 0, 0, 0.5);
    }
  }
  a { margin-right: 10px; }
}

.form-field {
  margin-top: 10px;
  &.checkbox {
    width: 200px;
    input, label { display: inline-block !important; }
    input:checked ~ i {
      display: block;
    }
  }
  &.means {
    label {
      border-radius: 5px;
      &.toggle:hover { background-color: rgb(230, 230, 230); }
    }
    li:hover { background-color: rgb(230, 230, 230); }
  }
  i {
    &.delete {
      display: none;
      float: right;
      margin-left: 10px;
      font-size: 1rem;
    }
  }
}
#manage-means, #manage-examples {
  span { display: inline-block; margin: 0 10px 15px 0; color: red; }
}

</style>
